import styled from 'styled-components';

import background from '../../assets/img/girls-podcast.jpg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  min-height: 100vh;
  width: 100%;

  .row-container {
    min-height: 100vh;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  animation: rendering 1s;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 50%;
  margin: auto;

  > img {
    height: 10rem;
    width: auto;
  }

  > label {
    font-family: 'Montserrat';
    font-size: 1.5rem;
    color: #b3b1b1;
    margin-left: -310px;
    margin-bottom: 10px;
  }

  > div:nth-of-type(2) {
    margin-top: 4px;
  }

  span {
    font-family: 'Montserrat';
    font-size: 1.2rem;
    color: #b3b1b1;
  }

  span:nth-of-type(1) {
    cursor: pointer;
  }

  button {
    margin: 40px 0px;
    background-color: #e84e22;
    outline: 0;
  }

  > div > span:nth-of-type(2) {
    color: #e84e22;
    font-weight: bold;
    margin-left: 4px;
  }

  @media (max-width: 1080px) {
    width: 100%;

    > label {
      margin-left: 0px;
    }
  }

  @media (max-width: 560px) {
    > div {
      width: 100%;
    }

    > button {
      width: 100%;
    }
  }
`;

export const Logo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  padding: 20px;

  box-shadow: 0 -3px 20px rgba(0, 0, 0, 0.2);

  background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.2) 15%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    url(${background}) no-repeat center;
  background-size: cover;

  @media (max-width: 1080px) {
    display: none;
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100vh;

  background: linear-gradient(
    180deg,
    var(--green2c) 0%,
    rgba(255, 255, 255, 1) 100%
  );

  background: linear-gradient(
    180deg,
    var(--green2c) 0%,
    rgba(255, 255, 255, 1) 16%,
    rgba(255, 255, 255, 1) 82%,
    var(--green2c) 100%
  );
  z-index: -1;
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
  text-align: center;
`;

export const SunflowerStudent = styled.div`
  margin-bottom: 30px;
  span:nth-of-type(2) {
    font-family: 'Montserrat';
    cursor: pointer;
    color: #e84e22;
    margin-left: 4px;
    font-size: 1.2rem;
  }
`;
